import { css } from 'styled-components';

export const infoTextTemplate = css`
  font-family: ${({ theme }) => theme.typography.fontFamily.font3};
  font-weight: ${({ theme }) => theme.typography.fontWeight[400]};
  font-size: 0.7em;
  line-height: 1.3;
`;
